export default "__VITE_ASSET__B8ilrPjR__"